module.exports = __webpack_public_path__ + "img/savedVideo.56059bc4.png";